<template lang="pug">
nav.breadcrumb(aria-label='breadcrumbs')
  .container
    ul
      li(v-if="isSearchPage")
        router-link(:to="{ name: 'search', params: { section: 'edition' }, query: routeQuery }")
          span {{ $t("searchResults")}}
          span(v-if="routeQuery.q") : „{{ routeQuery.q }}”
      li(v-if="isWatchlistPage") {{ $t("watchlist") }}
      li(v-if="isSearchPage || isWatchlistPage")
        a {{ page.sig }}
      li(v-else v-for="part in breadcrumb")
        router-link(:to="{ name: part.name, params: part.params }") {{ part.title }}
</template>

<script>
const { mapGetters, mapState } = require("vuex");
const { routeParamToSection, toc } = require("../../helpers/toc");

export default {
    name: "TranscriptBreadcrumb",
    computed: {
        breadcrumb() {
            const titles = [];
            let section = this.page.route.params.section;
            let path = toc.path(routeParamToSection(section), this.page.id) || [];
            path = path.filter((pe) => { return pe.title && (!pe.type || pe.type !== "volume") })
            path.push({ type: "page", firstAvailableFacsimile: this.page.id, title: this.page.sig })

            for(const p of path) {
                titles.push({
                    name: "transcript",
                    params: { id: p.firstAvailableFacsimile, section },
                    title: p.title
                });
            }

            return titles;
        },

        isSearchPage() {
            return this.page.route.params.section === "suche"
        },

        isWatchlistPage() {
            return this.page.route.params.section === "merkliste"
        },

        ...mapGetters("toc", { "page": "current" }),
        ...mapState("search", ["routeQuery"])
    }
}
</script>